import { render, staticRenderFns } from "./issue-home-users.vue?vue&type=template&id=1051601e&scoped=true"
import script from "./issue-home-users.vue?vue&type=script&lang=js"
export * from "./issue-home-users.vue?vue&type=script&lang=js"
import style0 from "./issue-home-users.vue?vue&type=style&index=0&id=1051601e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1051601e",
  null
  
)

export default component.exports